var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-content"},[_vm._v("\n  --- "+_vm._s(_vm.$t('message["1275"]'))+" ---\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }